import { MrbBaseRouteStore } from "mrb/core";
import { DeviceService, DayHourCacheService, WeekDayCacheService, UserSettingsService } from "common/services";

class DeviceEditRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = this.rootStore.createApplicationService(DeviceService);
        this.userSettingsService = this.rootStore.createApplicationService(UserSettingsService);
        this.dayHourService = new DayHourCacheService(this.rootStore);
        this.weekDayService = new WeekDayCacheService(this.rootStore);
    }

    updateUserDevice(resource) {
        return this.rootStore.userDeviceStore.updateUserDevice(resource);
    }

    deleteUserDevice(resource) {
        return this.rootStore.userDeviceStore.deleteUserDevice(resource);
    }

    getUserDevice(id) {
        return this.rootStore.userDeviceStore.getUserDevice(id, { embed: "device,device.systemType" });
    }

    getWeekDays() {
        return this.weekDayService.getItems();
    }

    getDayHours() {
        return this.dayHourService.getItems();
    }

    async findCertifiedModes() {
        const response = await this.userSettingsService.getCertifiedMode();
        return response.data;
    }

    async updateHideTrending(id, value) {
        const response = await this.service.updateHideTrending(id, value);
        return response.data;
    }
}

export default DeviceEditRouteStore;
